import { FunctionalLocationNode, WorkOrderWithScore } from './functional-location-hierarchy-scores-propagation.utils';

export class RawScoresCalculator {
  static calculateRawScores(node: FunctionalLocationNode): void {
    const workOrdersScore = this.calculateWorkOrdersScore(node);
    const childrenScore = node.Children.reduce((sum, child) => sum + child.Score, 0);
    node.Score = Math.max(0, workOrdersScore + childrenScore);
  }

  private static calculateWorkOrdersScore(node: FunctionalLocationNode): number {
    const releasedScore = node.ReleasedWorkOrders.reduce((sum, wo) => sum + wo.Score, 0);
    const notReleasedScore = node.NotReleasedWorkOrders.reduce((sum, wo) => sum + wo.Score, 0);
    return releasedScore + notReleasedScore;
  }
}
